export class NavigationModel
{
    public model: any[];

    constructor()
    {
        this.model = [/*
            {
                'id'      : 'applications',
                'title'   : 'Applications',
                'type'    : 'group',
                'children': [

                    {
                        'id'   : 'Prefijo',
                        'title': 'Prefijo',
                        'type' : 'item',
                        'icon' : 'email',
                        'url'  : '/Prefijo'
                        
                    },

                    {
                        'id'   : 'Tercero',
                        'title': 'Tercero',
                        'type' : 'item',
                        'icon' : 'people',
                        'url'  : '/Tercero'
                    },
                    
                    {
                        'id'   : 'Negocio',
                        'title': 'Negocio',
                        'type' : 'item',
                        'icon' : 'business',
                        'url'  : '/Negocio'

                    },
                    
                    {
                        'id'   : 'Factura',
                        'title': 'Enviar Facturas',
                        'type' : 'item',
                        'icon' : 'business',
                        'url'  : '/Factura'

                    },
                    
                    {
                        'id'   : 'CrearFactura',
                        'title': 'Crear Factura',
                        'type' : 'item',
                        'icon' : 'business',
                        'url'  : '/CrearFactura'

                    }

                ]
            }*/
            ];
        }
    }



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/navigation.model.ts